module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-180x180-3f8a88cc1db2bd51bd5b6879b00002d2.png";